import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenRedirection } from 'login-data-access';
import { FORMULARIO_ROUTES } from '../formulario-routes';

@Injectable({
  providedIn: 'root',
})
export class TokenServiceTsService {
  private router = inject(Router);

  redirectBasedOnFormulario(token: TokenRedirection): void {
    const formulario = token.FORMULARIO;
    const route = FORMULARIO_ROUTES[formulario] || 'painel/inicio'; // Rota padrão se não houver correspondência
    this.router.navigate([route]);
  }
}
